import { render, staticRenderFns } from "./App.vue?vue&type=template&id=03b0f893&scoped=true&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&id=03b0f893&prod&lang=scss&scoped=true&"
import style1 from "./App.vue?vue&type=style&index=1&id=03b0f893&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.10.1_css-loader@0.28.11_lodash@4.17.21_webpack@3.12.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b0f893",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/App.vue
// module id = 646
// module chunks = 58